import { HeaderProps } from '@/components/elements/header/Header'
import { Logo } from '@/components/shared/Logo'
import Link from 'next/link'
import styled from 'styled-components'
import { StyledHeaderContainer } from './HeaderStyledComponents'

const StyledMinimalHeader = styled.header<{ $backgroundColor: string }>`
  background-color: ${(props) => props.$backgroundColor};
`

const StyledMinimalHeaderContainer = styled(StyledHeaderContainer)`
  height: auto;
  padding: 32px 48px;
  text-align: center;

  svg.mobile,
  .logo-container-mobile {
    display: none;
  }

  svg.desktop {
    display: inline;
  }

  @media screen and (max-width: ${(props) => props.theme.breakpoints.tablet}) {
    display: block;
    height: auto;

    svg.mobile {
      display: inline;
    }

    .logo-container-mobile {
      display: block;
    }

    svg.desktop,
    .logo-container-desktop {
      display: none;
    }
  }
`

// This component is only used on the D30 checkout flow.
// It should be converted to a Design System component if we end up using it elsewhere.
export const MinimalHeaderNonSticky = ({ iconColour = 'brand', backgroundColor = 'transparent' }: HeaderProps) => {
  // NOTE: Assumes this component is not used on Dato pages - excludes the isPreview block

  return (
    <StyledMinimalHeader $backgroundColor={backgroundColor}>
      <StyledMinimalHeaderContainer>
        <Link href="/" passHref>
          <Logo colour={iconColour} size="desktop" />
          <Logo colour={iconColour} size="mobile" />
        </Link>
      </StyledMinimalHeaderContainer>
    </StyledMinimalHeader>
  )
}
